// Pristine landing snapshot.
//
// react-router rewrites the URL on first render — the quote funnel redirects
// `/app/quote/` → `/app/quote/<step>` and drops the query string before
// QuoteProvider's effects run. The TrackingTouch journal needs the ORIGINAL
// landing URL (utm_source, gclid, …) to record each touch's true entry
// channel, otherwise a touch built after the redirect resolves to "direct".
//
// We snapshot once at module-evaluation time. Module eval happens during
// bundle load — before createRoot()/render and therefore before any router
// redirect — so this captures the URL exactly as the user arrived on it.
//
// Read this instead of `window.location.search` when you need "how did the
// user arrive", not "where are they now".

const snapshot = {
  search: typeof window !== "undefined" ? window.location.search : "",
  pathname: typeof window !== "undefined" ? window.location.pathname : "/",
  referrer: typeof document !== "undefined" ? document.referrer : "",
};

export const initialLanding: Readonly<typeof snapshot> = snapshot;
